import isError from "../../utils/is-error";

const retry = (statusRegex, tries = 1) => fetch => {
  return (url, opts = {}) => {
    let retryCount = 0;
    const { retry = true } = opts;

    const handleRetry = resp => {
      const { status } = resp;
      if (retry && (statusRegex.test(status) || isError(resp))) {
        if (retryCount < tries) {
          retryCount++;
          return fetch(url, opts)
            .then(handleRetry)
            .catch(handleRetry);
        }
      }

      if (isError(resp)) {
        throw resp;
      }

      return resp;
    };

    return fetch(url, opts)
      .then(handleRetry)
      .catch(handleRetry);
  };
};

export default retry;
